<template>
	<main id="container" class="page-container mypage">
		<div class="page-header">
			<div class="container">
				<div class="display-flex is-between">
					<page-header title="마이페이지" />
				</div>
			</div>
		</div>
		<div class="page-content">
			<div class="mypage-tab-container">
				<div class="container button-wrap">
					<!-- <button classs="mypage-tab-button is-active"> -->
					<button :class="sortCd == 'F' ? 'mypage-tab-button is-active' : 'mypage-tab-button'" @click="showPage('F')">
						<span>찜한제품</span>
					</button>
					<!-- <button classs="mypage-tab-button is-active"> -->
					<button :class="sortCd == 'S' ? 'mypage-tab-button is-active' : 'mypage-tab-button'" @click="showPage('S')">
						<span>별점내역</span>
					</button>
					<button :class="sortCd == 'M' ? 'mypage-tab-button is-active' : 'mypage-tab-button'" @click="showPage('M')">
						<span>내 정보 관리</span>
					</button>
				</div>
			</div>
			<div class="container">
				<!-- 찜한제품 페이지 -->
				<div class="mypage-content" v-bind:class="{ active: sortCd === 'F' }">
					<div class="mypage-content-header">
						<p>
							<span class="mypage-name">{{ session.userNm }}</span> 님이 찜한 제품은 <span class="mypage-total boldtext">{{ likeData.prdTotal }}개</span>이며, 총 금액은 <span class="mypage-summ boldtext">{{ Number(likeData.prdSumm).toLocaleString() }}</span
							>원입니다.
						</p>
					</div>
					<div class="products-list">
						<products-item v-for="(item, idx) in favrManprdList" :key="item.manprdId" :id="item.id" :item="item" type="F" :evnt-strt-dt="evntStrtDt" :evnt-end-dt="evntEndDt" parent-like-evnt-nm="likeClicked" @likeClicked="handleClickLike" parent-click-evnt-nm="modalClicked" @modalClicked="handleClickModal" />
					</div>
				</div>
				<!-- 별점내역 페이지 -->
				<div class="mypage-content" v-bind:class="{ active: sortCd === 'S' }">
					<div class="mypage-content-header">
						<p>
							<span class="mypage-name">{{ session.userNm }}</span> 님이 평가한 제품은 <span class="mypage-total boldtext">{{ rateData.prdTotal }}개</span>이며, 평균 별점은 <span class="mypage-rate boldtext">{{ rateData.prdScore }}</span
							>입니다.
						</p>
					</div>
					<div class="products-list">
						<products-item v-for="(item, idx) in occtManprdList" :key="item.manprdId" :id="item.id" :item="item" type="S" :evnt-strt-dt="evntStrtDt" :evnt-end-dt="evntEndDt" parent-like-evnt-nm="likeClicked" @likeClicked="handleClickLike" parent-click-evnt-nm="modalClicked" @modalClicked="handleClickModal" />
					</div>
				</div>
				<!-- 회원탈퇴 페이지 -->
				<div class="mypage-content" v-bind:class="{ active: sortCd === 'M' }">
					<div class="mypage-content-body">
						<p class="mypage-content-body__desc">
							사용하고 계신 ID는 탈퇴할 경우, 재사용 및 복구가 불가능합니다.<br />
							또한 '온판' 플랫폼 회원에서도 탈퇴하게 되며, 이벤트 추첨 대상에서 제외됩니다.<br /><br />
							탈퇴한 ID는 본인과 타인 모두 재사용 및 복구가 불가능하며, 탈퇴 후 다른 ID로의 재가입은 가능합니다
						</p>
						<div class="buttons flex justify-content-center">
							<button type="button" class="button is-large is-rounded is-secondary" @click="clickWhdwlModal">회원탈퇴</button>
						</div>
					</div>
				</div>
			</div>
		</div>

		<products-modal :visible="visibleModal" @closeModal="visibleModal = false" :item="modalItem" :evnt-strt-dt="evntStrtDt" :evnt-end-dt="evntEndDt" parent-click-evnt-nm="clickEvnt" @clickEvnt="handleClickModalEvnt" />

		<div v-if="sortCd !== 'M'" class="pagination-wrap">
			<portal-pagination page-name="Category" :page-no="pageNo" :page-size="pageSize" :page-list-size="pageListSize" :total-count="totalCount" :query="queries" :parent-method-name="pagingMethodName" @getManprdList="getManprdList"></portal-pagination>
		</div>
	</main>
</template>

<script>
import PageHeader from '@/components/content/PageHeader';
import ProductsItem from '@/components/content/ProductsItem';
import PortalPagination from '@/components/PortalPaginationRoute';
import ProductsModal from '@/components/content/ProductsModal';
import { ACT_GET_CAMPN_MY_MANPRD_LIST, ACT_GET_SESSION, ACT_LOGIN_USER, ACT_USER_WHDWL, ACT_REMOVE_AUTH_TOKEN, ACT_GET_DHFESTA_EVENT_MNG } from '@/store/_act_consts';
import { MUT_SET_RETURN_ROUTE, MUT_SHOW_CONFIRM, MUT_SHOW_PROMPT, MUT_SHOW_ALERT } from '@/store/_mut_consts';
import { getCheckItems, lengthCheck, tryResCallback, setPaging, timestampToDateFormat, isSuccess, getItem, strToHex } from '@/assets/js/utils';
import SHA512 from 'crypto-js/sha512';
import Base64 from 'crypto-js/enc-base64';
import { mapGetters } from 'vuex';
export default {
	name: 'MyPage',
	components: { PageHeader, ProductsItem, ProductsModal, PortalPagination },
	data: () => ({
		name: '',
		likeData: {
			prdTotal: 0,
			prdSumm: 0,
		},
		rateData: {
			prdTotal: 0,
			prdScore: 0,
		},
		sortCd: 'F',
		//동행제품
		pagingMethodName: 'getManprdList',
		pageNo: 1,
		pageSize: 10,
		totalCount: 0,
		pageListSize: 10,
		visibleModal: false,
		modalId: 0,
		modalType: '',
		favrManprdList: [],
		occtManprdList: [],		
		evntStrtDt: '',
		evntEndDt: '',
	}),
	computed: {
		...mapGetters('common', ['commonCode', 'campn']),
		...mapGetters('auth', ['session', 'isAuth']),
		modalItem() {
			return this.sortCd === 'S' ? this.occtManprdList.find((i) => i.id == this.modalId) : this.favrManprdList.find((i) => i.id == this.modalId);
		},
		queries() {
			const result = {};
			result.searchName = this.searchName;
			result.ctgrDcd = this.ctgrDcd;
			return result;
		},
	},
	created() {
		if (!this.chkLogin('로그인 페이지로 이동합니다.')) return false;
		this.getManprdList(this.pageNo, this.sortCd);
		this.getEvntMng();
	},
	mounted() {},
	methods: {
		showPage(sortCd) {
			if (this.sortCd === sortCd) return false;
			this.pageNo = 1;
			this.sortCd = sortCd;
			this.getManprdList(this.pageNo, sortCd);
		},
		//  F: 찜순, S: 별점순 -- 상품 노출 영역
		getManprdList(pageNo, sortCd) {
			this.pageNo = pageNo;
			this.manprdList = [];
			if (typeof sortCd == 'undefined') sortCd = this.sortCd;
			// api 호출
			this.$store
				.dispatch(`manprd/${ACT_GET_CAMPN_MY_MANPRD_LIST}`, {
					campnId: this.campn.campnId,
					sortCd: sortCd,
					pageNo: this.pageNo,
					pageSize: this.pageSize,
				})
				.then((res) => {
					res.sortCd = sortCd;
					tryResCallback(this.tryCount, res, this.getManprdList, this.setManprdList);
				})
				.catch((e) => {
					console.error(e);
				});
		},
		setManprdList(res) {
			this.occtManprdList = [];
			this.favrManprdList = [];
			if (lengthCheck(res)) {
				if (res.sortCd === 'F') {
					this.favrManprdList = getCheckItems(res).map((i) => {
						return {
							id: i.manprdId,
							image: i.manprdImgFileUrl,
							company: i.brndNm,
							title: i.manprdNm,
							price: i.manprdPrc,
							rate: i.socreAvg,
							rateCount: i.scoreCnt,
							like: i.favrYn == 'Y',
							likeCount: i.favrCnt,
							myRate: i.myScore,
							desc: i.manprdDesc,
							siteUrl: i.ntslSiteUrl,
							isEng: false,
							useCampnDurYn: i.useCampnDurYn == 'Y',
							ntslStrtDt: timestampToDateFormat(i.ntslStrtDt, 'yyyy-MM-dd'),
							ntslEndDt: timestampToDateFormat(i.ntslEndDt, 'yyyy-MM-dd'),
						};
					});
				} else if (res.sortCd === 'S') {
					this.occtManprdList = getCheckItems(res).map((i) => {
						return {
							id: i.manprdId,
							image: i.manprdImgFileUrl,
							company: i.brndNm,
							title: i.manprdNm,
							price: i.manprdPrc,
							rate: i.socreAvg,
							rateCount: i.scoreCnt,
							like: i.favrYn == 'Y',
							likeCount: i.favrCnt,
							myRate: i.myScore,
							desc: i.manprdDesc,
							siteUrl: i.ntslSiteUrl,
							isEng: false,
							useCampnDurYn: i.useCampnDurYn == 'Y',
							ntslStrtDt: timestampToDateFormat(i.ntslStrtDt, 'yyyy-MM-dd'),
							ntslEndDt: timestampToDateFormat(i.ntslEndDt, 'yyyy-MM-dd'),
						};
					});
				}
				setPaging(this, res);
			} else {
				this.totalCount = 0;
			}
			if (res.sortCd === 'F') {
				this.likeData.prdTotal = this.favrManprdList.length;
				this.likeData.prdSumm = this.favrManprdList.reduce((total, b) => total + b.price, 0);
			} else {
				this.rateData.prdTotal = this.occtManprdList.length;
				if (this.occtManprdList.length > 0) this.rateData.prdScore = Math.round((this.occtManprdList.reduce((total, b) => total + b.myRate, 0) / this.occtManprdList.length) * 10) / 10;
				else this.rateData.prdScore = 0;
			}
		},
		// 찜하기
		handleClickLike(idx, type) {
			this.getManprdList(this.pageNo, type);
		},
		handleClickModal(idx, type) {
			this.modalId = idx;
			this.visibleModal = true;
		},
		handleClickModalEvnt(type, score) {
			this.getManprdList(this.pageNo, this.sortCd);
		},
		handleClickCtgr(dcd) {
			this.ctgrDcd = dcd;
			this.getManprdList(1);
		},
		chkLogin(title) {
			if (!this.isAuth) {
				const param = {
					title: title,
					html: true,
					showCancelButton: false,
					yesfunc: () => {
						this.$store.commit(`common/${MUT_SET_RETURN_ROUTE}`, this.$route.path);
						this.$router.push({ name: 'Login' });
					},
					nofunc: () => {},
				};
				this.$store.commit(`common/${MUT_SHOW_CONFIRM}`, param);
				return false;
			}

			return true;
		},
		async clickWhdwlModal() {
			//this.closeModal();

			await this.$store.commit(`common/${MUT_SHOW_PROMPT}`, {
				title: `비밀번호를 입력해주세요.`,
				showCancelButton: true,
				yesfunc: async (param) => {
					const res = await this.$store.dispatch(`auth/${ACT_GET_SESSION}`);
					this.item = getItem(res);
					const SYS_TYP_CD = '800';
					// this.isLoading = true;
					const LGN_ID = this.item.lgnId;
					// const PASSWD = this.passwd.trim();
					let PASSWD = strToHex(SHA512(param.trim()).toString(Base64));

					try {
						const authRes = await this.$store.dispatch(`auth/${ACT_LOGIN_USER}`, { LGN_ID, PASSWD, SYS_TYP_CD });
						this.lgnFailReason = authRes.result.code;
						this.isLoading = false;
						if (isSuccess(authRes) || this.session.userPattnCd == '400') {
							this.$store.commit(`common/${MUT_SHOW_CONFIRM}`, {
								title: `탈퇴하시겠습니까?`,
								showCancelButton: true,
								yesfunc: async () => {
									this.isLoading = true;
									await this.$store.dispatch(`auth/${ACT_USER_WHDWL}`, { lgnId: '' }).then((res) => {
										if (isSuccess(res)) {
											this.$store.dispatch(`auth/${ACT_REMOVE_AUTH_TOKEN}`);
											this.$store.commit(`common/${MUT_SHOW_ALERT}`, {
												title: '탈퇴가 완료되었습니다.',
												yesfunc: () => {
													this.$router.push({ name: 'Main' });
												},
											});
										} else if (res && res.result && res.result.number === 301) {
											this.$store.commit(`common/${MUT_SHOW_ALERT}`, {
												title: '마켓 입점 이력이 있습니다. <br/>고객센터에 문의해주세요. <br/>1899-0309',
												html: true,
											});
										} else if (res && res.result && res.result.number === 302) {
											this.$store.commit(`common/${MUT_SHOW_ALERT}`, {
												title: '관리자 권한이 부여되어 있습니다. <br/>고객센터에 문의해 주세요.<br/>1899-0309',
												html: true,
											});
										} else {
											this.$store.commit(`common/${MUT_SHOW_ALERT}`, {
												title: '탈퇴처리가 실패하였습니다. <br/>고객센터에 문의해 주세요.<br/>1899-0309',
												html: true,
											});
										}
									});
									this.isLoading = false;
								},
							});
						} else if (this.lgnFailReason === 'LGN_FAIL_TMS') {
							this.$store.commit(`common/${MUT_SHOW_ALERT}`, {
								title: '비밀번호를 5회 잘못 입력하셨습니다. <br/>본인인증 후 비밀번호를 재설정 해주세요.',
								yesfunc: () => {
									this.$store.dispatch(`auth/${ACT_REMOVE_AUTH_TOKEN}`);
									// this.$router.push({ name: 'FindInfo', params: { division: 'password' } });
									const DOMAIN_URL = process.env['VUE_APP_DOMAIN_URL'];
									window.location = `${DOMAIN_URL}/dhfindInfo/password`;
								},
								html: true,
							});
						} else {
							await this.$store.commit(`common/${MUT_SHOW_CONFIRM}`, {
								title: '비밀번호가 잘못되었습니다.',
								confirmButtonText: '다시입력',
								cancelButtonText: '닫기',
								showCancelButton: true,
								yesfunc: () => {
									this.clickWhdwlModal();
								},
							});
						}
					} catch (e) {
						console.error(e);
						this.viewError();
					}
				},
				nofunc: async () => {
					this.isLoading = false;
				},
			});
		},
		async getEvntMng() {
			this.evntStrtDt = '';
			this.evntEndDt = '';

			await this.$store
				.dispatch(`event/${ACT_GET_DHFESTA_EVENT_MNG}`, {
					campnId: this.campn.campnId,
					evntTyp: '20',
				})
				.then((res) => {
					if (lengthCheck(res)) {
						const item = getItem(res);
						this.evntStrtDt = timestampToDateFormat(Number(item.evntStrtDt), 'yyyy-MM-dd') + ' 00:00';
						this.evntEndDt = timestampToDateFormat(Number(item.evntEndDt), 'yyyy-MM-dd') + ' 00:00';

					} else {
						this.evntStrtDt = this.campn.strtDt;
						this.evntEndDt = this.campn.endDt;
					}
				});
		},
	},
};
</script>
